import React, { useEffect, useState } from 'react';
import { useFetch } from '../../../hooks/useFetch';
import { Pagination } from '../../pagination';
import { Filters } from '../filters/Filters';
import { useAuthToken } from '../../../hooks/useAuthToken';
import { apiConfig } from '../../../api/apiConfig';
const landingImages = require.context('../../../assets/images', true);
/**
 * Creado por Equilibrio Agency 2023<br>
 * Listado sección encuestas
 * @interface ScoresUsersSection
 */
export const ScoresUsersSection = () => {
  const getProgressByCourse = (coursesProgress, courseId) => {
    const course = coursesProgress?.find((c) => c?.courseId === courseId);
    return course ? `${course?.progress}%` : '-';
  };
  const parseProgress = (value) => {
    if (!value || value === '-') return 0;
    return Number(parseFloat(value.replace('%', '')).toFixed(1)) || 0;
  };
  const totalCoursesCompleted = (coursesProgress) => {
    if (!Array.isArray(coursesProgress)) return 0;
    return coursesProgress.filter((c) => Number(c.progress) === 100).length;
  };
  const countStartedSpecificCourses = (coursesProgress) => {
    const courseIds = ['yo-emprendo-descubrir', 'yo-emprendo-comprender', 'yo-emprendo-crear'];
    let count = 0;
    courseIds.forEach((id) => {
      const progress = parseProgress(getProgressByCourse(coursesProgress, id));
      if (progress > 0) {
        count++;
      }
    });
    return count;
  };
  const countCompletedSpecificCourses = (coursesProgress) => {
    const courseIds = ['yo-emprendo-descubrir', 'yo-emprendo-comprender', 'yo-emprendo-crear'];
    let count = 0;
    courseIds.forEach((id) => {
      if (parseProgress(getProgressByCourse(coursesProgress, id)) === 100) {
        count++;
      }
    });
    return count;
  };
  const [scores, setScores] = useState([]);
  const [scoresFull, setScoresFull] = useState([]);
  const [total, setTotal] = useState(1);
  const [data, handleFetch] = useFetch();

  const [dataFilter, setDataFilter] = useState({
    name: '',
    lastname: '',
    document: '',
    studentType: '',
  });
  const { authToken } = useAuthToken(true);
  const [segment, setSegment] = useState([]);
  const { isLogged, getSessionUser } = useAuthToken(true);
  const logged = isLogged();
  const [adminSegment, setAdminSegment] = useState(0);
  const sessionUser = getSessionUser();

  const viewSegments = () => {
    const responsesegment = handleFetch({
      url: `bo/segment?&companyId=${apiConfig.company}`,
      method: 'GET',
      headers: { Authorization: `Bearer ${authToken}` },
    });
    responsesegment.then(
      (r) => {
        let filtrados = [];
        if (logged) {
          if (sessionUser?.segmentId === null) {
            setAdminSegment(true);
          } else {
            setAdminSegment(true);
            filtrados = r.data.filter((registro) => sessionUser?.segmentId.includes(registro.type));
          }
        }
        setSegment(filtrados?.length !== 0 ? filtrados : r.data);
      },
      (error) => {
        console.log(error.errors);
      }
    );
  };
  // Consulta de endpoint listado de encuestas
  useEffect(() => {
    viewSegments();
    let filtername = dataFilter.name !== '' ? `&name=` + dataFilter.name : '';
    let filterlastname = dataFilter.lastname !== '' ? `&lastname=` + dataFilter.lastname : '';
    let filterdocument = dataFilter.document !== '' ? '&document=' + dataFilter.document : '';
    let filterstudenttype =
      dataFilter.studentType !== ''
        ? '&type=' + dataFilter.studentType
        : sessionUser?.segmentId !== null
          ? '&type=' + sessionUser?.segmentId[0]
          : '';
    const response = handleFetch({
      url: `bo/scoresusers?&companyId=${apiConfig.company}${filtername}${filterlastname}${filterdocument}${filterstudenttype}`,
      method: 'GET',
      headers: { Authorization: `Bearer ${authToken}` },
    });
    response.then(
      (r) => {
        const _filteredUsers = r.map((user) => {
          return {
            ...user,
            etapa1: getProgressByCourse(user?.courses, 'yo-emprendo-descubrir'),
            etapa2: getProgressByCourse(user?.courses, 'yo-emprendo-comprender'),
            etapa3: getProgressByCourse(user?.courses, 'yo-emprendo-crear'),
            progAvg: (
              (parseProgress(getProgressByCourse(user?.courses, 'yo-emprendo-descubrir')) +
                parseProgress(getProgressByCourse(user?.courses, 'yo-emprendo-comprender')) +
                parseProgress(getProgressByCourse(user?.courses, 'yo-emprendo-crear'))) /
              3
            ).toFixed(2),
            totalCourses: countStartedSpecificCourses(user?.courses),
            coursesCompleted: countCompletedSpecificCourses(user?.courses),
          };
        });
        setScores(_filteredUsers);
        setScoresFull(_filteredUsers);
        setTotal(_filteredUsers.length);
      },
      (error) => {
        console.log(error.errors);
      }
    );
  }, [total]);
  // Handle para registrar información de campos en filtros
  const handleChangeFilter = ({ target }) => {
    setDataFilter({
      ...dataFilter,
      [target.name]: target.value,
    });
  };
  // Función para activar filtros, recibe parametros del mismo
  const handleSubmit = async (e) => {
    e.preventDefault();
    let filtername = dataFilter.name !== '' ? `&name=` + dataFilter.name : '';
    let filterlastname = dataFilter.lastname !== '' ? `&lastname=` + dataFilter.lastname : '';
    let filterdocument = dataFilter.document !== '' ? '&document=' + dataFilter.document : '';
    let filterstudenttype =
      dataFilter.studentType !== ''
        ? '&type=' + dataFilter.studentType
        : sessionUser?.segmentId !== null
          ? '&type=' + sessionUser?.segmentId[0]
          : '';
    const response = handleFetch({
      url: `bo/scoresusers?&companyId=${apiConfig.company}${filtername}${filterlastname}${filterdocument}${filterstudenttype}`,
      method: 'GET',
      headers: { Authorization: `Bearer ${authToken}` },
    });
    response.then(
      (r) => {
        const _filteredUsers = r.map((user) => {
          return {
            ...user,
            etapa1: getProgressByCourse(user?.courses, 'yo-emprendo-descubrir'),
            etapa2: getProgressByCourse(user?.courses, 'yo-emprendo-comprender'),
            etapa3: getProgressByCourse(user?.courses, 'yo-emprendo-crear'),
            progAvg: (
              (parseProgress(getProgressByCourse(user?.courses, 'yo-emprendo-descubrir')) +
                parseProgress(getProgressByCourse(user?.courses, 'yo-emprendo-comprender')) +
                parseProgress(getProgressByCourse(user?.courses, 'yo-emprendo-crear'))) /
              3
            ).toFixed(2),
            totalCourses: countStartedSpecificCourses(user?.courses),
            coursesCompleted: totalCoursesCompleted(user?.courses),
          };
        });
        setScores(_filteredUsers);
        setScoresFull(_filteredUsers);
        setTotal(_filteredUsers.length);
      },
      (error) => {
        console.log(error.errors);
      }
    );
  };
  useEffect(() => {
    if (logged) {
      const sessionUser = getSessionUser();
      if (sessionUser?.segmentId === 0) {
        setAdminSegment(true);
      } else {
        setAdminSegment(false);
      }
    }
  }, []);
  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12">
          <div className="row justify-content-center">
            <div className="col-12 text-center">
              <h1
                style={{
                  fontSize: '36px',
                  fontWeight: '700',
                  lineHeight: '46.8px',
                  letterSpacing: '-1%',
                }}
              >
                Progreso usuarios
              </h1>
            </div>
          </div>
          <div className="row justify-content-center" style={{ marginTop: '30px' }}>
            <Filters
              downloadCSV={true}
              filename={'listscoresusers.csv'}
              onSubmit={handleSubmit}
              data={scoresFull}
            >
              <div className="FilterAdmin__options">
                <span className="FilterAdmin__input-title">Nombre</span>
                <div>
                  <input
                    type="text"
                    name="name"
                    value={dataFilter?.name || ''}
                    onChange={handleChangeFilter}
                    placeholder="Nombre"
                    className={`FilterAdmin__input`}
                  />
                </div>
              </div>
              <div className="FilterAdmin__options">
                <span className="FilterAdmin__input-title">Apellido</span>
                <div>
                  <input
                    type="text"
                    name="lastname"
                    value={dataFilter?.lastname || ''}
                    onChange={handleChangeFilter}
                    placeholder="Apellido"
                    className={`FilterAdmin__input`}
                  />
                </div>
              </div>
              <div className="FilterAdmin__options">
                <span className="FilterAdmin__input-title">Documento</span>
                <div>
                  <input
                    type="text"
                    name="document"
                    value={dataFilter?.document || ''}
                    onChange={handleChangeFilter}
                    placeholder="Documento"
                    className={`FilterAdmin__input`}
                  />
                </div>
              </div>
              {adminSegment && (
                <div className="FilterAdmin__options">
                  <span className="FilterAdmin__input-title">Segmentación</span>
                  <div>
                    <select
                      className={`form-select FilterAdmin__input`}
                      name="studentType"
                      value={dataFilter?.studentType || ''}
                      onChange={handleChangeFilter}
                    >
                      {segment.length !== 0
                        ? segment.map((segm, index) => {
                            return (
                              <option value={segm.type} key={index}>
                                {segm.name}
                              </option>
                            );
                          })
                        : ''}
                    </select>
                  </div>
                </div>
              )}
            </Filters>
          </div>
          <div className="row justify-content-center">
            <div className="" style={{ width: '90%', marginTop: '17px', overflowX: 'auto' }}>
              {data.loading ? (
                <Loading />
              ) : (
                <UsersTable scores={scores} total={total} dataFilter={dataFilter} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
/**
 * Creado por Equilibrio Agency 2022<br>
 * Función para listar encuestas
 * @param {JSON} scores Información de encuestas
 * @param {string} total Cantidad total de encuestas
 * @function UsersTable
 */
const UsersTable = ({ scores, total, dataFilter }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 50;
  const offset = currentPage * itemsPerPage;
  const currentItems = scores.slice(offset, offset + itemsPerPage);
  const [page, setPage] = useState(0);
  // Header para listado de encuestas
  const headers = [
    {
      name: 'NOMBRE USUARIO',
      sort_name: 'nameuser',
      width: '25%',
    },
    {
      name: 'DOCUMENTO',
      sort_name: 'document',
      width: '15%',
    },
    {
      name: 'T.CURSOS',
      sort_name: 'total',
      width: '10%',
    },
    {
      name: 'COMPLET.',
      sort_name: 'completed',
      width: '10%',
    },
    {
      name: 'PROGR.AVG',
      sort_name: 'avgprogress',
      width: '10%',
    },
    {
      name: 'C/ PROGR.',
      sort_name: 'withprogress',
      width: '10%',
    },
    {
      name: 'S/ PROGR.',
      sort_name: 'withoutprogress',
      width: '10%',
    },
    {
      name: 'CERTIF.',
      sort_name: 'certificates',
      width: '10%',
    },
  ];

  const [, setUsersSorted] = useState(scores);
  const [, setTotalSorted] = useState(total);
  const [, setUserHovered] = useState(Array(scores?.length).fill(false));

  useEffect(() => {
    setUsersSorted(scores);
    setTotalSorted(total);
  }, [scores, total]);

  const resetState = () => {
    setUserHovered(Array(scores.length).fill(false));
  };

  const handleActiveRow = (index) => {
    let auxArray = Array(scores.length).fill(false);
    auxArray[index] = true;
    setUserHovered(auxArray);
  };

  const [, handleFetch] = useFetch();
  const { authToken } = useAuthToken(true);
  // Handle para paginación
  const handlePageClick = (event) => {
    let result = 50 * event.selected;
    setCurrentPage(event.selected);
    let filtername = dataFilter.name !== '' ? `&name=` + dataFilter.name : '';
    let filterlastname = dataFilter.lastname !== '' ? `&lastname=` + dataFilter.lastname : '';
    let filterdocument = dataFilter.document !== '' ? '&document=' + dataFilter.document : '';
    setPage(event.selected);
    const response = handleFetch({
      url: `bo/scoresusers?&companyId=${apiConfig.company}&$skip=${result}${filtername}${filterlastname}${filterdocument}`,
      method: 'GET',
      headers: { Authorization: `Bearer ${authToken}` },
    });
    response.then(
      (r) => {
        setUsersSorted(r);
        setTotalSorted(r.length);
      },
      (error) => {
        console.log(error.errors);
        if (error.errors) {
          // Error handling can be implemented here if needed
        }
      }
    );
  };
  return (
    <>
      <table className="UserAdmin__table">
        <thead className="UserAdmin__table-header" style={{ height: '52px' }}>
          <tr style={{ cursor: 'pointer' }}>
            {headers.map((header, index) => {
              return (
                <th
                  key={index}
                  className="overflow"
                  style={{ width: header.width, paddingLeft: '16px' }}
                >
                  {header.name}
                </th>
              );
            })}
            <th style={{ width: '13%' }}></th>
          </tr>
        </thead>
        <tbody>
          {currentItems.length !== 0 ? (
            currentItems.map((cert, index) => {
              return (
                <tr
                  onMouseLeave={resetState}
                  onMouseEnter={() => {
                    handleActiveRow(index);
                  }}
                  className={`UserAdmin__table-row ${index % 2 === 0 ? 'UserAdmin__table-pair-row' : 'UserAdmin__table-odd-row'}`}
                  key={index}
                >
                  <td className="overflow" style={{ paddingLeft: '16px' }}>
                    {cert.name} {cert.lastname}
                  </td>
                  <td className="overflow" style={{ paddingLeft: '16px' }}>
                    {cert.documentType} {cert.document}
                  </td>
                  <td className="overflow" style={{ paddingLeft: '16px', textAlign: 'center' }}>
                    {cert.totalCourses}
                  </td>
                  <td className="overflow" style={{ paddingLeft: '16px', textAlign: 'center' }}>
                    {cert.coursesCompleted}
                  </td>
                  <td className="overflow" style={{ paddingLeft: '16px', textAlign: 'center' }}>
                    {cert.progAvg}%
                  </td>
                  <td className="overflow" style={{ paddingLeft: '16px', textAlign: 'center' }}>
                    {cert.coursesWithProgress}
                  </td>
                  <td className="overflow" style={{ paddingLeft: '16px', textAlign: 'center' }}>
                    {cert.coursesWithoutProgress}
                  </td>
                  <td className="overflow" style={{ paddingLeft: '16px', textAlign: 'center' }}>
                    {cert.coursesWithCertificate}
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="11" style={{ padding: '16px', textAlign: 'center' }}>
                <strong>No se encontraron registros</strong>
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <Pagination
        itemsPerPage={50}
        totalElements={total}
        onChangePage={handlePageClick}
        forcePage={page}
      />
    </>
  );
};

/**
 * Creado por Equilibrio Agency 2022<br>
 * Función Loading
 * @function Loading
 */
const Loading = () => {
  const loadingImage = landingImages('./icons/loading_spin_ean.svg');
  return (
    <div className="d-flex justify-content-center" style={{ minHeight: '300px' }}>
      <div className="row text-center position-absolute justify-content-center">
        <img alt="Loader" src={loadingImage} />
      </div>
    </div>
  );
};
